"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WILL_START = exports.STOPPING = exports.STARTING = exports.IDLE = exports.DICTATING = void 0;
var IDLE = 0;
exports.IDLE = IDLE;
var WILL_START = 1;
exports.WILL_START = WILL_START;
var STARTING = 2;
exports.STARTING = STARTING;
var DICTATING = 3;
exports.DICTATING = DICTATING;
var STOPPING = 4;
exports.STOPPING = STOPPING;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zdGFudHMvRGljdGF0ZVN0YXRlLmpzIl0sIm5hbWVzIjpbIklETEUiLCJXSUxMX1NUQVJUIiwiU1RBUlRJTkciLCJESUNUQVRJTkciLCJTVE9QUElORyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsSUFBTUEsSUFBSSxHQUFHLENBQWI7O0FBQ0EsSUFBTUMsVUFBVSxHQUFHLENBQW5COztBQUNBLElBQU1DLFFBQVEsR0FBRyxDQUFqQjs7QUFDQSxJQUFNQyxTQUFTLEdBQUcsQ0FBbEI7O0FBQ0EsSUFBTUMsUUFBUSxHQUFHLENBQWpCIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgSURMRSA9IDA7XG5jb25zdCBXSUxMX1NUQVJUID0gMTtcbmNvbnN0IFNUQVJUSU5HID0gMjtcbmNvbnN0IERJQ1RBVElORyA9IDM7XG5jb25zdCBTVE9QUElORyA9IDQ7XG5cbmV4cG9ydCB7IERJQ1RBVElORywgSURMRSwgU1RBUlRJTkcsIFNUT1BQSU5HLCBXSUxMX1NUQVJUIH07XG4iXX0=